import * as types from "../constants";

const initialState = {
  isLoading: false,
  error: null,
  items: [],
};

export default function crmCompaniesReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_CRM_COMPANIES_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_CRM_COMPANIES_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_CRM_COMPANIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
